import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/use-auth";
import { FreelancerDashboard } from "@/components/FreelancerDashboard";
import { ClientDashboard } from "@/components/ClientDashboard";

export const Route = createFileRoute("/_authenticated/dashboard")({
  head: () => ({
    meta: [
      { title: "Dashboard — Lumvio" },
      {
        name: "description",
        content:
          "Your Lumvio dashboard: track active projects, review pending invoices, monitor payment protection balance, and jump into client conversations.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: DashboardPage,
});

function DashboardPage() {
  const { profile } = useAuth();
  const { t } = useTranslation();

  if (!profile) {
    return (
      <div className="py-24 text-center text-muted-foreground">{t("common.loading")}</div>
    );
  }

  return profile.role === "freelancer" ? <FreelancerDashboard /> : <ClientDashboard />;
}
